'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getPremiumUrl = getPremiumUrl;

var _WixInstance = require('@wix/wixrest-utils/dist/WixInstance');

var _WixInstance2 = _interopRequireDefault(_WixInstance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getPremiumUrl() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        referral = _ref.referral;

    var appDefId = _WixInstance2.default.getAppId();
    var instanceId = _WixInstance2.default.getInstanceId();
    return 'https://premium.wix.com/wix/api/premiumStart?instanceId=' + instanceId + '&appDefId=' + appDefId + '&referralAdditionalInfo=' + referral;
}

exports.default = {
    getPremiumUrl: getPremiumUrl
};